import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CircularProgress, IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {getAddresse, getDataInString} from "../RightAccordion";
import IconesRight from "../../pages/compos/IconesRight";
import InfoIcon from "@mui/icons-material/Info";
import {resBdnb} from "../AttributBdnb";
import {computeSurface} from "../../pages/dpeByIris/MapPage";


export function getParcellePrincipale(listOfParcelles, isPrincipal = true) {
    if (isPrincipal) {
        let res = ""
        listOfParcelles.forEach(p => {
            if (p.parcelle_principale === 't') {
                res = p.parcelle_id
            }
        });
        return res
    } else {
        let res = []
        listOfParcelles.forEach(p => {
            if (p.parcelle_principale !== 't') {
                res.push(p.parcelle_id)
            }
        })
        return res.join(", ")
    }
}

export function computeEmpriseAuSol(batiments) {
    let total = 0;
    let insertedBat = {}
    batiments.forEach(b => {

        if (!insertedBat[b["batiment_construction_id"]]) {
            total += Number(b.s_geom_cstr);
            insertedBat[b["batiment_construction_id"]] = true
        }
    })
    return total;
}

export function computeSurfaceUtile(batiments, annee_construction) {
    let total = computeSurface(batiments, annee_construction);
    return total;
}

export function computeSuperficieParcelle(listOfParcelles, isPrincipal = true) {
    if (isPrincipal) {
        let res = 0
        listOfParcelles.forEach(p => {
            if (p.parcelle_principale === 't') {
                res = p.s_geom_parcelle
            }
        });
        return res
    } else {
        let res = 0
        listOfParcelles.forEach(p => {
            if (p.parcelle_principale !== 't') {
                res += p.s_geom_parcelle
            }
        })
        return res
    }
}

export function getAddresse2(selectedItem) {
    let addresse = "";
    if (selectedItem.numero) {
        addresse = addresse + " " + selectedItem.numero;
    }
    if (selectedItem.rep) {
        addresse = addresse + " " + selectedItem.rep;
    }

    if (selectedItem.type_voie) {
        addresse = addresse + " " + selectedItem.type_voie;
    }
    if (selectedItem.nom_voie) {
        addresse = addresse + " " + selectedItem.nom_voie;
    }
    if (selectedItem.libelle_commune) {
        addresse = addresse + ", " + selectedItem.libelle_commune;
    }


    return addresse;
}

export function getAddresse3(selectedItem) {
    let addresse = "";
    if (selectedItem.numero) {
        addresse = addresse + "_" + selectedItem.numero;
    }
    if (selectedItem.rep) {
        addresse = addresse + "_" + selectedItem.rep;
    }

    if (selectedItem.type_voie) {
        addresse = addresse + "_" + selectedItem.type_voie;
    }
    if (selectedItem.nom_voie) {
        addresse = addresse + "_" + selectedItem.nom_voie;
    }
    if (selectedItem.libelle_commune) {
        addresse = addresse + "_" + selectedItem.libelle_commune;
    }

    return addresse;
}

export function getAddresses(batiments) {

    let addresses = {};
    batiments.forEach(b => {
        addresses[getAddresse2(b)] = true;
    });

    return Object.keys(addresses)

}

export default function HeaderDetails({selectedItem}) {
    const [open, setOpen] = React.useState(true);

    return (<Accordion
        sx={{
            margin: 2,
            '&:before': {
                display: 'none',
            },
            boxShadow: "none",
            borderColor: "rgba(0, 0, 0, 0.125)",
            borderStyle: "solid",
            borderWidth: 1,
            borderRadius: "8px",
            width: "95%"
        }}
        expanded={open}

    >
        <AccordionSummary
            expandIcon={<ExpandMoreIcon/>}
            onClick={() => {
                setOpen(!open)
            }}

        >
            <Typography variant="h5"
                        sx={{color: "#fff", backgroundColor: "#1f0d88", fontWeight: "bold", p: 1.2}}
                        gutterBottom>{getDataInString(getAddresse(selectedItem))}
            </Typography>

        </AccordionSummary>
        <AccordionDetails>

            <Box sx={{
                width: "95%",
                borderRadius: "8px",
                backgroundColor: "#f7f9fc",
                padding: 2,
                m: 1,
            }}>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%",}}>
                        <Typography color={"#550505005050"} variant="body2" display="block"
                                    gutterBottom>Adresses groupées</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        {getAddresses(selectedItem.batiments).join(", ")}
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#550505005050"} variant="body2" display="block"
                                    gutterBottom>Numéro de Parcelle principale</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                        >{getParcellePrincipale(selectedItem.listOfParcelles, true)}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#550505005050"} variant="body2" display="block"
                                    gutterBottom>Numéro de Parcelle(s) connexe(s)</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{getParcellePrincipale(selectedItem.listOfParcelles, false)}</Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Année de construction</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{selectedItem.metadonnees[0].annee_construction}</Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Superficie Parcelle principale</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        {computeSuperficieParcelle(selectedItem.listOfParcelles, true)} m²
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Superficie Parcelle(s) connexe(s)</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        {computeSuperficieParcelle(selectedItem.listOfParcelles, false)} m²
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Emprise au sol</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        {computeEmpriseAuSol(selectedItem.batiments)} m²
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%", display: "flex", alignItems: "center"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Surface utile calculée : </Typography>
                        <Tooltip
                            title="Hauteur de l'immeuble / hauteur d'étage(s) type = Nbre d'étage(s) / Surface au sol X Nbre d'étage(s) calculé(s)) X 90% = surface utile du bâtiment">
                            <IconButton>
                                <InfoIcon/>
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        {computeSurfaceUtile(selectedItem.batiments, selectedItem.metadonnees[0].annee_construction)} m²
                    </Box>
                </Box>
            </Box>
        </AccordionDetails>
    </Accordion>)
}

